export { UppyComponent } from "./Uppy";
export type { AllowedSources } from "./Uppy";
